import CardSdm from 'components/CardSdm';
import HorizontalCard from 'components/HorizontalCard';
// import MainButton from 'components/MainButton';
import Layout from 'Layout'
import React, { useCallback, useEffect, useState } from 'react'
import IcBoy from 'assets/icons/ic-boy.png'
import IcGirl from 'assets/icons/ic-girl.png'
import IcBoyGirl from 'assets/icons/ic-boyGirl.png'
// import Imsdg1 from "assets/images/im-sdg1.jpg";
import IcNschool from "assets/icons/ic-notSchool.png";
import IcSd from 'assets/icons/ic-sd.png'
import IcSmp from 'assets/icons/ic-smp.png'
import IcSma from 'assets/icons/ic-sma.png'
import IcGraduate from 'assets/icons/ic-graduate.png'
import IcPencil from "assets/icons/ic-pencil.png";
import IcNotw from 'assets/icons/ic-not work.png';
import IcWrst from 'assets/icons/ic-wiraswasta.png';
import IcHouseK from 'assets/icons/ic-hk.png';
import IcStudents from 'assets/icons/ic-students.png';
import IcFarmer from 'assets/icons/ic-farmer.png';
import IcFreelancer from 'assets/icons/ic-freelancer.png'
import DropdownSdm from 'components/DropdownSdm';
import { getSdm } from 'services/apiRoutes';
import IcPns from 'assets/icons/ic-pns.jpg';
import IcArtist from 'assets/icons/ic-artist.png';
import IcPensiun from 'assets/icons/ic-pensiun.png';
import ImSdg from 'assets/images/sdm.jpg'
import { useParams } from 'react-router-dom';

export default function Sdm() {
  const {slug}=useParams()
  const [sdm, setSdm] = useState();

  const sdmAPI = useCallback(async () => {
    const res = await getSdm(slug);
    if (res.error) {
      return res.message;
    } else {
      const { data } = res.data;
      setSdm(data);
    }
  }, [slug]);

  useEffect(() => {
    sdmAPI();
  }, [sdmAPI]);
  return (
    <Layout>
      <div className="px-5 xl:pt-44 py-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold mb-14 xl:text-7xl xl:mb-20">
          Sumber Daya Manusia
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Sumber Daya Manusia"
            img={ImSdg}
          />
        </div>
        {/* <div className="flex my-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden xl:justify-end">
          <div className="text-sm font-bold">Filter</div>
          <MainButton secondType label="SDGs" />
          <MainButton secondType label="BLT" />
          <MainButton secondType label="Data covid" />
        </div> */}
        <h1 className="text-lg font-bold mb-14 xl:text-5xl xl:mt-36">
          Demografi Penduduk
        </h1>
        <div className="xl:px-16 p-5 bg-borderSdg rounded-[18px] py-16 justify-between xl:flex-col xl:flex  space-y-5 xl:space-y-0 ">
          <div className="justify-between w-full space-y-5 xl:flex xl:space-x-5 xl:mb-5 xl:space-y-0">
            <div className="w-full">
              <CardSdm
                icons={IcBoy}
                title="Laki-laki"
                counter={
                  sdm?.jk[0]?.jumlah === "0"
                    ? "Tidak ada data"
                    : sdm?.jk[0]?.jumlah
                }
              />
            </div>
            <div className="w-full">
              <CardSdm
                icons={IcGirl}
                title="Perempuan"
                counter={
                  sdm?.jk[1]?.jumlah === "0"
                    ? "Tidak ada data"
                    : sdm?.jk[1]?.jumlah
                }
              />
            </div>
          </div>
          <div>
            <CardSdm
              icons={IcBoyGirl}
              title="Total"
              counter={
                sdm?.totalPenduduk === "0"
                  ? "Tidak ada data"
                  : sdm?.totalPenduduk
              }
            />
          </div>
          <DropdownSdm>
            <div className="h-full bg-primary rounded-2xl">
              <table className="items-center w-full text-center shadow-xl table-fixed">
                <thead className="text-white bg-none rounded-3xl">
                  <tr className="text-sm font-semibold ">
                    <th>Jenis Kelamin</th>
                    <th>Jumlah</th>
                  </tr>
                </thead>
                <tbody className="rounded">
                  <tr className="font-semibold bg-white border">
                    <td>Laki-laki</td>
                    <td>
                      {sdm?.jk[0]?.jumlah === "0"
                        ? "Tidak ada data"
                        : sdm?.jk[0]?.jumlah}
                    </td>
                  </tr>
                  <tr className="font-semibold bg-white border">
                    <td>Perempuan</td>
                    <td>
                      {sdm?.jk[1]?.jumlah === "0"
                        ? "Tidak ada data"
                        : sdm?.jk[1]?.jumlah}
                    </td>
                  </tr>
                  <tr className="font-semibold bg-white border">
                    <td>Total</td>
                    <td>
                      {sdm?.totalPenduduk === "0"
                        ? "Tidak ada data"
                        : sdm?.totalPenduduk}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </DropdownSdm>
        </div>
        <h1 className="text-lg font-bold my-14 xl:text-5xl xl:my-16">
          Pendidikan
        </h1>
        <div className="xl:px-16 p-5   wrapperDemografi bg-borderSdg rounded-[18px] py-16 justify-between xl:flex xl:space-x-10 space-y-5 xl:space-y-0">
          <div className="justify-between space-y-5 xl:w-full">
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcNschool}
                  title="Tidak/Belum Sekolah"
                  counter={
                    sdm?.pendidikan[0]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[0]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcSd}
                  title="Tamat SD/Sederajat"
                  counter={
                    sdm?.pendidikan[2]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[2]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcSmp}
                  title="SLTP/Sederajat"
                  counter={
                    sdm?.pendidikan[3]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[3]?.jumlah
                  }
                />
              </div>
            </div>
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcSma}
                  title="SLTA/Sederajat"
                  counter={
                    sdm?.pendidikan[4]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[4]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcPencil}
                  title="Belum Tamat SD/Sederajat"
                  counter={
                    sdm?.pendidikan[1]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[1]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcGraduate}
                  title="Diploma I / II"
                  counter={
                    sdm?.pendidikan[5]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[5]?.jumlah
                  }
                />
              </div>
            </div>
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcGraduate}
                  title="Akademi / D-III / Sarjana Muda"
                  counter={
                    sdm?.pendidikan[6]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[6]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcGraduate}
                  title="Diploma IV/Strata I"
                  counter={
                    sdm?.pendidikan[7]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[7]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcGraduate}
                  title="Strata II"
                  counter={
                    sdm?.pendidikan[8]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pendidikan[8]?.jumlah
                  }
                />
              </div>
            </div>

            <div className="w-full">
              <CardSdm
                icons={IcGraduate}
                title="Strata III"
                counter={
                  sdm?.pendidikan[9]?.jumlah === "0"
                    ? "Tidak ada data"
                    : sdm?.pendidikan[9]?.jumlah
                }
              />
            </div>
            <DropdownSdm>
              <div className="h-full bg-primary rounded-2xl">
                <table className="items-center w-full text-center shadow-xl table-fixed">
                  <thead className="text-white bg-none rounded-3xl">
                    <tr className="text-sm font-semibold ">
                      <th>Jenis Pendidikan</th>
                      <th>Jumlah</th>
                    </tr>
                  </thead>
                  <tbody className="rounded">
                    {sdm
                      ? sdm.pendidikan.map((item, index) => (
                          <tr
                            className="font-semibold bg-white border"
                            key={index}
                          >
                            <td>{item.namaPendidikan}</td>
                            <td>
                              {item.jumlah === "0"
                                ? "Tidak ada data"
                                : item.jumlah}
                            </td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
              </div>
            </DropdownSdm>
          </div>
        </div>
        <h1 className="text-lg font-bold my-14 xl:text-5xl xl:my-16">
          Pekerjaan
        </h1>
        <div className="xl:px-16 p-5 wrapperDemografi bg-borderSdg rounded-[18px] py-16 justify-between xl:flex xl:space-x-10 space-y-5 xl:space-y-0">
          <div className="justify-between space-y-5 xl:w-full">
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcNotw}
                  title="Belum/Tidak Bekerja"
                  counter={
                    sdm?.pekerjaan[0]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[0]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcWrst}
                  title="Wiraswasta"
                  counter={
                    sdm?.pekerjaan[87]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[87]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcHouseK}
                  title="Mengurus Rumah Tangga"
                  counter={
                    sdm?.pekerjaan[1]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[1]?.jumlah
                  }
                />
              </div>
            </div>
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcStudents}
                  title="Pelajar/Mahasiswa"
                  counter={
                    sdm?.pekerjaan[2]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[2]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcFarmer}
                  title="Petani/Pekebun"
                  counter={
                    sdm?.pekerjaan[19]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[19]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcFreelancer}
                  title="Buruh Harian Lepas"
                  counter={
                    sdm?.pekerjaan[18]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[18]?.jumlah
                  }
                />
              </div>
            </div>
            <div className="justify-between space-y-5 xl:flex xl:space-y-0 xl:space-x-5">
              <div className="w-full">
                <CardSdm
                  icons={IcPns}
                  title="Pegawai Negeri Sipil"
                  counter={
                    sdm?.pekerjaan[4]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[4]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcPensiun}
                  title="Pensiunan"
                  counter={
                    sdm?.pekerjaan[3]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[3]?.jumlah
                  }
                />
              </div>
              <div className="w-full">
                <CardSdm
                  icons={IcArtist}
                  title="Seniman"
                  counter={
                    sdm?.pekerjaan[35]?.jumlah === "0"
                      ? "Tidak ada data"
                      : sdm?.pekerjaan[35]?.jumlah
                  }
                />
              </div>
            </div>
            <DropdownSdm>
              <div className="h-full bg-primary rounded-2xl">
                <table className="items-center w-full text-center shadow-xl table-fixed">
                  <thead className="text-white bg-none rounded-3xl">
                    <tr className="text-sm font-semibold ">
                      <th>Jenis Pekerjaan</th>
                      <th>Jumlah</th>
                    </tr>
                  </thead>
                  <tbody className="rounded">
                    {sdm
                      ? sdm.pekerjaan.map((item, index) => (
                          <tr
                            className="font-semibold bg-white border"
                            key={index}
                          >
                            <td>{item.namaPekerjaan}</td>
                            <td>
                              {item.jumlah === "0"
                                ? "Tidak ada data"
                                : item.jumlah}
                            </td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
              </div>
            </DropdownSdm>
          </div>
        </div>
      </div>
    </Layout>
  );
}
